<template>
  <div class="mb-5" v-if="visible">
    <label
      class="preliminary-custom-label mb-4"
      :data-identifier="field.identifier"
      >{{ field.label }}</label
    >

    <div
      class="question-container"
      :class="{
        'question-container--two-columns': field.inputValues.length <= 2,
      }"
    >
      <div
        v-for="(inputValue, index) in field.inputValues"
        :id="`prelimInput_${field.identifier}_${index}`"
        :key="field.identifier + index"
        @click="setSelection(inputValue)"
      >
        <!--Icon style-->
        <div
          v-if="inputValue.labelIcon"
          class="answer-tile has-text-grey-icon cursor-pointer"
          :class="{ 'answer-tile--active': selectedValue === inputValue.value }"
        >
          <b-icon
            icon-pack="fa"
            :icon="inputValue.labelIcon"
            type="is-grey-icon"
            size="is-large"
            class="mb-1"
          ></b-icon>

          <br />

          <span>{{ inputValue.text }}</span>
        </div>

        <!--Radio style-->
        <div
          v-else
          class="answer-tile__radio"
          :class="{
            'answer-tile__radio--active': selectedValue === inputValue.value,
          }"
        >
          <b-radio
            v-if="isLeasing"
            v-model="selectedValue"
            :name="field.identifier"
            :native-value="inputValue.value"
            type="is-black"
          >
            {{ inputValue.text }}
          </b-radio>
          <b-radio
            v-else
            v-model="selectedValue"
            :name="field.identifier"
            :native-value="inputValue.value"
            type="is-blue"
          >
            {{ inputValue.text }}
          </b-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreliminaryRadioQuestion",
  props: {
    field: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  computed: {
    isLeasing() {
      return /^\/leasing.*/i.test(this.$route.path);
    },
  },
  mounted() {
    this.selectedValue =
      this.$store.getters["preliminaryAssessment/answer"](
        this.field.identifier
      ) || null;
    this.$watch("selectedValue", this.valueWatcher);
  },
  methods: {
    valueWatcher() {
      this.$store.dispatch("preliminaryAssessment/addData", {
        question: this.field.identifier,
        answer: this.selectedValue,
      });
    },
    setSelection(inputValue) {
      this.selectedValue = inputValue.value;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/colors.scss";

$border-color: #dfe6ef;

label.preliminary-custom-label {
  color: #363636;
  font-weight: 700;
  display: block;

  .dealer-branding-wrapper & {
    color: var(--black);
  }
}

.question-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  &--two-columns {
    grid-template-columns: repeat(2, 1fr);
  }

  .answer-tile {
    border: 1px solid $border-color;
    border-radius: 1rem;
    padding: 0.7rem;
    text-align: center;
    font-size: 0.75rem;
    overflow: hidden;
    word-break: break-word;
    height: 100%;
    transition: all 0.1s;

    &--active {
      border: 2px solid $blue;
      color: $blue !important;

      .dealer-branding-wrapper & {
        border-color: var(--branding-secondary, black);
        color: var(--branding-secondary, 0px) !important;
      }
    }

    .icon {
      font-size: 1.2rem;
      color: inherit !important;
    }
  }

  .answer-tile__radio {
    border: 1px solid $border-color;
    border-radius: 1rem;
    padding: 2rem 0.7rem;
    overflow: hidden;
    word-break: break-word;
    height: 100%;
    text-align: center;

    &--active {
      color: $blue !important;

      .dealer-branding-wrapper & {
        border-color: var(--branding-secondary, black);
        color: var(--branding-secondary, 0px) !important;
      }
    }

    .radio:hover {
      color: inherit;
    }

    .dealer-branding-wrapper & {
      background: white;
      border-radius: var(--card-border-radius, 0px);
      cursor: pointer;
    }
  }
}

@media only screen and (min-width: 769px) {
  .answer-tile {
    padding: 2rem !important;
  }
}
</style>
